import React from "react";
import styled from "styled-components"

const Styled={
    MenuRecommendBox:styled.div`
        width:40px;
        height:20px;
        margin-right:5px;
        border-radius:5px;
        background-color:#DCEAFF;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
    `,
        MenuRecommendText:styled.p`
            font-size:10px;
            font-weight:400;
            color:#2277F6;
            font-family:'PreFont';
        `,
}

const NewMenu=()=>{
    return(
        <Styled.MenuRecommendBox>
            <Styled.MenuRecommendText>신메뉴</Styled.MenuRecommendText>
        </Styled.MenuRecommendBox>
    )
}
export default NewMenu